import apiService from '../enviroment';
import { loaderService } from './loaderService';

const getMods = async () => {
  loaderService.show();
  try {
    const response = await apiService.get('insights/admin/unidad/negocio/');
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const getUsers = async () => {
  loaderService.show();
  try {
    const response = await apiService.get('admin/usuarios/');
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

const postMods = async (params) => {
  loaderService.show();
  try {
    const response = await apiService.post('insights/admin/unidad/negocio/', params);
    if (response.status === 200) {
      loaderService.hide();
      return response.data;
    }
  } catch (error) {
    loaderService.hide();
    return false;
  }
};

export { getMods, getUsers, postMods };
